import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { module } from 'modujs'

gsap.registerPlugin(ScrollTrigger)

export default class extends module {
  init() {
    this.pageEl = this.el.parentElement.querySelector('.page')
    this.videoEl = this.el.querySelector('.c-footer_cover')
    this.imageEl = this.el.querySelector('.c-footer_left_media')

    this.sc = ScrollTrigger.create({
      trigger: this.pageEl,
      start: 'bottom bottom',
      endTrigger: this.el.parentElement,
      end: 'bottom bottom',
      onEnter: () => {
        this.videoEl.classList.remove('is-hidden')
        this.imageEl.classList.remove('is-hidden')
      },
      onEnterBack: () => {
        this.videoEl.classList.remove('is-hidden')
        this.imageEl.classList.remove('is-hidden')
      },
      onLeaveBack: () => {
        this.videoEl.classList.add('is-hidden')
        this.imageEl.classList.add('is-hidden')
      }
    })
  }

  destroy() {
    this.sc.kill()
  }
}
